import { Injectable } from '@angular/core';
import {
  ActiveState,
  EntityState,
  EntityStore,
  StoreConfig,
} from '@datorama/akita';
import { User } from '@etrucking/iam/core';

export interface UsersState
  extends EntityState<User, string>,
    ActiveState<string> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'iam.users', idKey: 'uid' })
export class UsersStore extends EntityStore<UsersState> {
  constructor() {
    super();
  }
}
